import { createSelector } from 'reselect';
import margedById from '../../../helpers/margeById';

const pendingSuppliersStateSelector = state => state.pendingSuppliers;
const selectById = (state, itemId) => itemId;

export const pendingSuppliersSelector = createSelector(
  [pendingSuppliersStateSelector],
  suppliers => suppliers.items
);

export const pendingSuppliersAsListSelector = createSelector(
  [pendingSuppliersSelector],
  suppliers =>
    suppliers.map(supplier => {
      // return {
      //   moderationId: supplier._id,
      //   _id: supplier.supplierData[0]?._id,
      //   businessName: supplier.supplierData[0]?.businessName,
      // };
      // console.log(suppliers)
      return {
        supplierId: supplier._id,
        businessName: supplier.businessName
      };
    })
);

/* export const pendingSuppliersAsListSelector = createSelector(
  [pendingSuppliersSelector],
  (suppliers) =>
    suppliers.map((supplier) => {
      if (supplier.supplierData.length > 0) {
         
      return {
        moderationId: supplier._id,
        _id: supplier.supplierData[0]._id,
        businessName: supplier.supplierData[0].businessName,
      };
    }

    })
); */

export const pendingSuppliersIsLoadingSelector = createSelector(
  [pendingSuppliersStateSelector],
  suppliers => suppliers.isLoading
);

export const pendingSuppliersCountSelector = createSelector(
  [pendingSuppliersStateSelector],
  suppliers => suppliers.count
);

export const pendingSupplierByIdSelector = createSelector(
  [pendingSuppliersSelector, selectById],
  (suppliers, _id) => {
    const pendingSupplier = suppliers.find(item => _id === item._id);
    console.log(pendingSupplier, _id);
    if (!pendingSupplier) return null;
    return pendingSupplier;
  }
);
